import React from 'react';
import { STEP_LABELS } from '../../constants';

interface HoraCertaStepperProps {
  step: number;
}

export const HoraCertaStepper = ({ step }: HoraCertaStepperProps) => (
  <ol
    aria-label="Etapas da importação"
    className="flex items-center w-full max-w-4xl mx-auto gap-2 text-xs font-semibold"
  >
    {STEP_LABELS.map((label, index) => {
      const number = index + 1;
      const isDone = number < step;
      const isActive = number === step;
      return (
        <React.Fragment key={label}>
          <li
            className={`flex items-center gap-2 shrink-0 ${
              isActive ? 'text-[#EE7C2C]' : 'text-slate-500'
            }`}
          >
            <span
              className={`w-6 h-6 rounded-full flex items-center justify-center text-xs ${
                isActive
                  ? 'bg-[#EE7C2C] text-white'
                  : isDone
                  ? 'bg-emerald-500 text-white'
                  : 'border border-slate-300 text-slate-400'
              }`}
            >
              {isDone ? '✓' : number}
            </span>
            <span>
              {number}. {label}
            </span>
          </li>
          {number < STEP_LABELS.length && (
            <li
              aria-hidden
              className={`flex-1 h-[2px] mx-2 ${
                isDone ? 'bg-[#EE7C2C]' : 'bg-slate-200'
              }`}
            />
          )}
        </React.Fragment>
      );
    })}
  </ol>
);
